<script lang="ts" setup>
  withDefaults(defineProps<{ as?: string; measure?: string; intrinsic?: boolean }>(), {
    as: 'div',
    measure: '60ch',
    intrinsic: false,
  });
</script>

<template>
  <component :is="as" class="center" :data-intrinsic="intrinsic" :style="{ maxWidth: measure }">
    <slot />
  </component>
</template>

<style scoped>
  .center {
    box-sizing: content-box;
    margin-inline: auto;
  }

  .center[data-intrinsic='true'] {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
</style>
